import { Skeleton } from "@/components/ui/skeleton";

const NextDepartureSkeleton = () => (
  <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-4">
    <Skeleton className="h-3 w-24 mb-3" />
    <Skeleton className="h-7 w-32 mb-2" delay={40} />
    <Skeleton className="h-3 w-40 mb-3" delay={80} />
    <Skeleton className="h-4 w-full" delay={120} />
  </div>
);

export default NextDepartureSkeleton;
